module.exports = __webpack_public_path__ + "files/b14c62282e9ec66ebcaa18f96efbdbc8.png";